/**
* Awards Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Awards Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'awards-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.awards-slider.splide' ).each( function( index, element ) {
        const awardsSlider = new Splide( element, {
          type: 'loop',
          perPage: 1,
          perMove: 1,
          gap: '1rem',
          pagination: false,
          autoplay: true,
          speed: 800,
          fixedWidth: '240px',
        } );

        awardsSlider.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'awards-slider', COMPONENT );
} )( app );
